/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';
import { resizableCellStyles, resizerStyles } from '../internal/resizable-table-styles';

/**
 * TableCellItem CSS
 */
export const styles = css`
  :host {
    --min-cell-width:auto;
    --cell-width:auto;
    --min--height: 52px;
    --max--cell-width: auto;
    --padding: var(--nile-spacing-xl , var(--ng-spacing-lg)) var(--nile-spacing-3xl , var(--ng-spacing-3xl));
    box-sizing: border-box;
    display: table-cell;
    vertical-align: middle;
    padding: var(--padding);
    max-width: var(--max--cell-width);
    min-height: var(--min--height);
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .column {
    min-width:var(--min-cell-width);
    width:var(--cell-width);
    height: 100%;
    color: var(--nile-colors-gray-light-mode-600 , var(--ng-colors-text-tertiary-600));
    font-family: var(--nile-font-family-serif , var(--ng-font-family-body));
    font-size: var(--nile-type-scale-3 , var(--ng-font-size-text-sm));
    font-style: normal;
    font-weight: var(--nile-font-weight-regular , var(--ng-font-weight-regular));
    /* line-height: var(--nile-type-scale-6); */
    line-height: normal;
    letter-spacing: 0.2px;
  }

  ${resizableCellStyles}
  ${resizerStyles}
`;

export default [styles];
